import { Module } from 'vuex';
import {
	download,
	getFile,
	updateFileWithFile,
	updateFileWithObject,
} from '@/store/gapi';

export interface StorageState {
	lastSave: any;
	loadOnce: boolean;
}

// eslint-disable-next-line @typescript-eslint/ban-types
const storageModule: Module<StorageState, {}> = {
	state: {
		loadOnce: false,
		lastSave: null,
	},
	mutations: {
		setFile(state, file) {
			state.lastSave = file;
			state.loadOnce = true;
		},
	},
	actions: {
		async loadSavedFile({ commit }) {
			console.log('loading file...');
			const file = await getFile();
			commit('setCollection', file);
			commit('setFile', file);
			console.log('load done!');
		},
		async isAuthenticated({ dispatch }, isAuthenticated) {
			if (!isAuthenticated) return;
			dispatch('loadSavedFile');
		},
		async download({ rootGetters }) {
			if (!rootGetters.isUserAuthenticated) return;
			await download();
		},
		async upload({ rootGetters, dispatch }, file) {
			console.log('upload file...', JSON.parse(await file.text()));
			if (!rootGetters.isUserAuthenticated) return;
			await updateFileWithFile(file);
			console.log('upload done!');
			dispatch('loadSavedFile');
		},
		async updateSavedFile({ state, rootGetters }) {
			console.log('updateSavedFile...');
			if (!rootGetters.isUserAuthenticated) return;
			if (!state.loadOnce) return;
			await updateFileWithObject(rootGetters.fileContents);
			console.log('updateSavedFile done!');
		},
	},
};

export default storageModule;
